import isUnifiedProfilePhotoEnabled from '../../utilities/isUnifiedProfilePhotoEnabled';

interface ProfileImage {
	position?: number | string;
	POSITION?: number | string;
	description?: string;
	DESCRIPTION?: string;
	url?: string;
	URL?: string;
}

const getProfileImageUrl = (
	imageData: string | ProfileImage[] | null | undefined,
	fallbackImagePath = '',
): string => {
	const unifiedProfilePhotoEnabled = isUnifiedProfilePhotoEnabled();

	let parsedImageData = imageData;
	if (typeof parsedImageData === 'string') {
		try {
			parsedImageData = JSON.parse(parsedImageData);
		} catch {
			parsedImageData = [];
		}
	}

	if (!Array.isArray(parsedImageData)) {
		return fallbackImagePath;
	}

	const selectedImage = parsedImageData.find((img) => {
		const position = Number(img?.position ?? img?.POSITION);
		if (!unifiedProfilePhotoEnabled) {
			return position === 1;
		}

		const description = String(
			img?.description ?? img?.DESCRIPTION ?? '',
		).toLowerCase();
		return position === 3 && description === 'profile-photo-circle';
	});

	return selectedImage?.url || selectedImage?.URL || fallbackImagePath;
};

export default getProfileImageUrl;
